/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentParcelsParcelidCancel200,
  PostApiV1IndividualpaymentParcelsParcelidCancel401,
  PostApiV1IndividualpaymentParcelsParcelidCancel404,
  PostApiV1IndividualpaymentParcelsParcelidCancel500,
  PostApiV1IndividualpaymentParcelsParcelidCancelMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidCancelPathParams,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentParcelsParcelidCancel.ts";

export const postApiV1IndividualpaymentParcelsParcelidCancelPathParamsSchema =
  z.object({
    parcelId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidCancelPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentParcelsParcelidCancel200Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidCancel200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentParcelsParcelidCancel401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidCancel401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1IndividualpaymentParcelsParcelidCancel404Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidCancel404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentParcelsParcelidCancel500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidCancel500>;

export const postApiV1IndividualpaymentParcelsParcelidCancelMutationResponseSchema =
  z.lazy(
    () => postApiV1IndividualpaymentParcelsParcelidCancel200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidCancelMutationResponse>;
